import Transport from './card-transportation';
import Docs from './card-docs';
import Training from './card-training';
import Medical from './card-medical-waste';
import Neutral from './card-neutralization';

const cardsServices = {
    Transport,
    Docs,
    Training,
    Medical,
    Neutral
};

export default cardsServices;